import { animateScroll } from 'react-scroll';

const getScrollCoord = (target, container, indentation) => {
    let currentNode = target;
    let scrollCoord = 0;
    while (currentNode !== container) {
        scrollCoord += currentNode.offsetTop;
        currentNode = currentNode.offsetParent;
    }

    return scrollCoord - indentation;
};

export const scrollToInvalid = (containerSelector = '.content-scroll') => {
    const target = document.querySelector('.invalid');
    const body = document.querySelector('body');
    const scrollContainer = document.querySelector(containerSelector);
    const container = scrollContainer || body;

    if (target && container) {
        container.setAttribute('id', 'validation-scroll-container');
        animateScroll.scrollTo(getScrollCoord(target, container, scrollContainer ? 15 : 60), {
            duration: 300,
            delay: 300,
            containerId: 'validation-scroll-container',
            smooth: true
        });
        container.removeAttribute('id');
    }
};
